"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumb = void 0;
var react_1 = __importDefault(require("react"));
var breadcrumb_1 = require("@chakra-ui/breadcrumb");
var icons_1 = require("@chakra-ui/icons");
var layout_1 = require("@chakra-ui/layout");
var react_2 = require("react");
exports.BreadCrumb = (0, react_2.memo)(function (_a) {
    var breadcrumbDatas = _a.breadcrumbDatas;
    return (react_1.default.createElement(layout_1.Box, { bg: "#f7f6f4", borderTop: "1px", borderBottom: "1px", borderColor: "#d4cdc3", height: "4rem" },
        react_1.default.createElement(breadcrumb_1.Breadcrumb, { overflowX: "auto", whiteSpace: "nowrap", mx: "1rem", maxW: { md: "100%", xl: "1240px" }, fontSize: { base: "1.2rem" }, spacing: "8px", separator: react_1.default.createElement(icons_1.ChevronRightIcon, { color: "gray.500" }) }, breadcrumbDatas.map(function (breadcrumbData, index) { return (react_1.default.createElement(breadcrumb_1.BreadcrumbItem, { h: "4rem", key: "breadcrumbItem-" + index },
            react_1.default.createElement(breadcrumb_1.BreadcrumbLink, { _focus: { outline: "none" }, href: "/" + breadcrumbData.front_path }, breadcrumbData.name))); }))));
});
